import styled from 'styled-components';
import { COLOR, mobile, STYLE } from './variables';
import { hexOpacity, invertHex } from '../utils/helper/styling';

export const Article = styled.article`
    background-color: transparent;
    z-index: 9;
    position: relative;
`;

export const H1 = styled.h1`
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.3;
    margin-top: 0;
`;

export const H2 = styled.h2`
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.3;
    margin: 1rem 0;
`;

export const H3 = styled.h3`
    font-size: 1rem;
    font-weight: 600;
`;

export const H4 = styled.h4`
    font-size: 1rem;
    font-weight: 600;
`;

export const H5 = styled.h5`
    font-size: 1rem;
    font-weight: 600;
`;

export const P = styled.p<{ light?: boolean }>`
    opacity: ${({ light }) => (light ? 0.55 : 1)};
    margin-top: 1.5em;
    margin-bottom: 2em;
`;

export const A = styled.a<{ light?: boolean }>`
    color: ${({ light }) => (light ? invertHex(COLOR.contentFont) : COLOR.contentFont)};
    opacity: 1 !important;
    text-decoration: underline;
    cursor: pointer;
`;

export const Strong = styled.strong`
    font-weight: 600;
`;

export const Em = styled.em`
    font-style: italic;
`;

export const Section = styled.section`
    //width: ${STYLE.content.width};
    //max-width: ${STYLE.content.maxWidth};
    //margin: 0 25% 4em 10%;
      width: 100%;
      padding: 0 25% 4em 10%;
    color: ${COLOR.contentFont};
    background-color: ${COLOR.contentBackground};

    @media ${mobile} {
        max-width: unset;
        margin-top: 0;
        margin-right: 0;
        margin-left: 0;
        width: 100%;
      padding: 0 0 2em 0;
    }
`;

export const Block = styled.div<{ isOverlay?: boolean }>`
    background-color: ${COLOR.contentBackground};
    margin-top: ${({ isOverlay }) => (isOverlay ? '-6rem' : `0`)};
    margin-right: ${STYLE.content.margin.right};
    margin-left: ${STYLE.content.margin.left};
    padding-top: ${STYLE.content.padding.top};
    padding-right: ${STYLE.content.padding.right};
    padding-bottom: ${STYLE.content.padding.bottom};
    padding-left: ${STYLE.content.padding.left};
    position: ${({ isOverlay }) => (isOverlay ? 'relative' : `initial`)};

    @media ${mobile} {
        margin-top: 0;
        padding-right: 0;
        padding-bottom: 0;
        padding-left: 0;
    }
`;

export const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 2em;
`;

export const ListItem = styled.li`
    position: relative;
    padding-left: 1.25rem;

    :before {
        display: block;
        position: absolute;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiA2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDBoNnY2SDB6IiBmaWxsPSIjY2NjY2NjIi8+Cjwvc3ZnPg==);
        background-repeat: no-repeat;
        background-size: contain;
        content: ' ';
        height: 6px;
        left: 0;
        top: 0.55rem;
        width: 6px;
    }
`;

export const Column = styled.section`
    display: flex;
    flex-flow: column;
`;

export const Note = styled.div`
    color: ${COLOR.br24.lightMediumGrey};
    padding: 0 0.5rem;
    text-align: right;
    font-size: 0.85rem;
    line-height: 1.25;
`;

export const ErrorWrapper = styled.div`
    padding: 1em;
    margin-top: 1rem;
    border: 1px solid ${COLOR.error};
    background-color: ${hexOpacity(COLOR.error, 0.25)};
`;

export const Highlight = styled.span<{ color?: string; tColor?: string }>`
    background: ${({ color = COLOR.primary }) => color};
    padding: 0 4px;
    color: ${({ color = COLOR.overlayFont }) => color};
    border-radius: 5px;
    word-break-inside: none;
    box-decoration-break: clone;
`;
